module.exports = __webpack_public_path__ + "img/avator.d53a6237.svg";